import { createContext, useContext, useCallback, useReducer } from "react";
import useResetableStorage from "app/utils/useResetableStorage";
import {
  INITIAL_STATE,
  buzzInReducer,
  BuzzInAction,
  type BuzzInState,
} from "app/buzz-in/buzzInState";

export function useBuzzInReducer(storageKey: string) {
  const serializer = (state: BuzzInState): string => JSON.stringify(state);
  const deserializer = (value: string): BuzzInState => JSON.parse(value);

  const [savedState, setSaveState] = useResetableStorage(
    storageKey,
    INITIAL_STATE,
    { raw: false, serializer, deserializer },
  );

  const reducerLocalStorage = useCallback(
    (state: BuzzInState, action: BuzzInAction) => {
      const newState = buzzInReducer(state, action);
      setSaveState(newState);
      return newState;
    },
    [setSaveState],
  );

  return useReducer(reducerLocalStorage, savedState || INITIAL_STATE);
}

export const BuzzInDispatchContext = createContext<
  React.Dispatch<BuzzInAction>
>(() => {});

export function useBuzzInActionDispatch() {
  return useContext(BuzzInDispatchContext);
}

export const BuzzInContext = createContext<BuzzInState>(INITIAL_STATE);

export function useBuzzInState() {
  return useContext(BuzzInContext);
}
